import styled from 'styled-components';

export const Container = styled.div`
  height: 100vh;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  display: flex;
`;
